import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input  } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { Subscription } from '../../../../../node_modules/rxjs';
import { BoxQuotaData } from '../../../model/box.quote.data';

@Component({
    selector: 'cu-download-link-cell-ordertype-renderer',
    template: `<span>{{typeString}}</span><span  [ngClass]="{'isicon isstop':isStop, 'd-none':!isStop}">S</span><span  [ngClass]="{'isicon islimit':isLimit, 'd-none':!isLimit}">L</span>`
  })

  
  export class orderTypeCellRenderer {
      params:any;
      constructor( ) { 

      }
      
      private _typeString:string = "";

      public set typeString(v:string)
      {
        this._typeString = v;
      }

      public get typeString():string
      {
        return this._typeString;
      }

     private _isStop: boolean = false;
    public get isStop (): boolean {
      return this._isStop;
    }
    public set isStop ( value: boolean ) {
      this._isStop = value;
    }

    private _isLimit: boolean = false;
    public get isLimit (): boolean {
      return this._isLimit;
    }
    public set isLimit ( value: boolean ) {
      this._isLimit = value;
    }


      agInit(params:any): void { 
          this.params = params;
         

           this.typeString = ( this.params.data.Type!=null )?String(this.params.data.Type):""; 
           this.isStop = ( this.params.data.Stop>0 )?true:false; 
           this.isLimit = ( this.params.data.Limit>0 )?true:false; 
         
     }
    


     refresh(params: any): void {
      this.params = params;
      this.typeString = ( this.params.data.Type!=null )?String(this.params.data.Type):""; 
      this.isStop = ( this.params.data.Stop>0 )?true:false; 
      this.isLimit = ( this.params.data.Limit>0 )?true:false; 
      // console.log("refreshPNL");
      // console.log(this.params.data);
      

      // this.pnlString = ( this.params.data.PnLUSD!=null )?String(this.params.data.PnLUSD):""; 
         
      // if( this.pnlString!=null)
      //   {
      //     let direction:number = this.pnlString.indexOf("-");

      //     if(direction>=0)
      //     {
      //       this.PnlValue = -1;
      //     }
      //     else{
      //       this.PnlValue = 1;
      //     }

      //     if(this.pnlString=="$0.00")
      //     {
      //       this.PnlValue=0;
      //     }
      //   }
      //   else
      //   {
      //     this.pnlString = "";
      //   }
      }

  }
  
  export type CellAction = (params:any) => void;